import API from "./";

export const UploadSnapshot = (image) =>
  API.post("/projects/snapshots/", { image });
